import { API_URL, CONTACT_INFO_API_TOKEN } from '../../config';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

const fetchWithAuth = async (url: string, lang: string) => {
  url = applyPreproductionSettings(url);
  if (lang.includes('zh')) {
    url += url.includes('?') ? '&locale=zh-Hant-HK&fallbackLocale=false' : '?locale=zh-Hant-HK&fallbackLocale=false';
  }
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${CONTACT_INFO_API_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchContactInfo = async (lang: string) => {
  try {
    const contactInfoResponse = await fetchWithAuth(
      `${API_URL}/contact-info?populate=ContactUsBanner.BannerImage,ContactUsBanner.BannerImageTab,ContactUsBanner.BannerImageMob,SetOfContacts.Columns,ContactUsButtonLink,TypeOfCustomerOptions,TypeOfEnquiryOptionsForConsumer,TypeOfEnquiryOptionsForBusiness,ContactUsSEO.MetaImage,ContactUsGA,AboutBanner.BannerImage,AboutBanner.BannerImageTab,AboutBanner.BannerImageMob,AboutButtonLink,AboutSEO.MetaImage,AboutGA&pagination[limit]=-1`,
      lang
    );

    const contactInfo = contactInfoResponse.data;

    console.log('fetchContactInfo API Response:', contactInfo);
    return contactInfo;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};